/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type { ElaboranetTargetDto } from ".././models";

export const getApiElaboranetTargets = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<ElaboranetTargetDto[]>> => {
  return axios.get(`/api/elaboranet/targets`, options);
};

export const getGetApiElaboranetTargetsQueryKey = () =>
  [`/api/elaboranet/targets`] as const;

export const getGetApiElaboranetTargetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiElaboranetTargets>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiElaboranetTargets>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getApiElaboranetTargets>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiElaboranetTargetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiElaboranetTargets>>
  > = ({ signal }) => getApiElaboranetTargets({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type GetApiElaboranetTargetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiElaboranetTargets>>
>;
export type GetApiElaboranetTargetsQueryError = AxiosError<unknown>;

export const useGetApiElaboranetTargets = <
  TData = Awaited<ReturnType<typeof getApiElaboranetTargets>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getApiElaboranetTargets>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetApiElaboranetTargetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const __$$useGetApiElaboranetTargets = () =>
  //@ts-ignore
  useGetApiElaboranetTargets(...([] as any[]));
